import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { InvoiceStatusEnum } from "../../data/enums";

export namespace WhatsAppInvoiceValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                status: v.optional(v.picklist(InvoiceStatusEnum.values)),
                associateId: v.optional(v.string()),
            }),
        }),
    );

    export const Payment = defineValidation(
        v.object({
            paymentDate: baseVals.isoDate("Tanggal Pembayaran"),
            notes: v.optional(baseVals.string()),
        }),
    );
}
